import React, { useEffect, useState } from "react";
import api, { inr } from "../../lib/api";
import { Package, FolderTree, Users, Activity } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminOverview() {
    const [data, setData] = useState(null);
    useEffect(() => {
        document.title = "Admin Overview | Loomara";
        api.get("/analytics/summary").then(({ data }) => setData(data));
    }, []);

    if (!data) return <p className="text-ink-500" data-testid="admin-loading">Loading dashboard…</p>;

    const cards = [
        { label: "Products", value: data.totals.products, icon: Package },
        { label: "Categories", value: data.totals.categories, icon: FolderTree },
        { label: "Customers", value: data.totals.customers, icon: Users },
        { label: "Events Tracked", value: data.totals.events, icon: Activity },
    ];

    return (
        <div data-testid="admin-overview">
            <p className="eyebrow">Welcome back</p>
            <h1 className="font-serif text-4xl text-ink-900 mt-2">Boutique Overview</h1>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
                {cards.map((c) => (
                    <div key={c.label} className="card-soft p-6">
                        <c.icon size={20} className="text-sage-600 mb-3" strokeWidth={1.5} />
                        <p className="text-xs uppercase tracking-[0.22em] text-ink-500">{c.label}</p>
                        <p className="font-serif text-4xl text-ink-900 mt-2">{c.value}</p>
                    </div>
                ))}
            </div>

            <div className="grid lg:grid-cols-3 gap-6 mt-10">
                <TopList title="Top Viewed" items={data.topViewed} metric="views" />
                <TopList title="Top WhatsApp Clicks" items={data.topWhatsapp} metric="whatsappClicks" />
                <TopList title="Top Buy Now Clicks" items={data.topBuyNow} metric="buyNowClicks" />
            </div>

            <div className="card-soft p-6 mt-10">
                <h3 className="font-serif text-2xl text-ink-900">Recent Customers</h3>
                {data.recentUsers.length === 0 ? (
                    <p className="text-ink-500 text-sm mt-3">No customer signups yet.</p>
                ) : (
                    <ul className="mt-4 divide-y divide-sage-300/20">
                        {data.recentUsers.map((u) => (
                            <li key={u.id} className="py-3 flex justify-between text-sm">
                                <span className="text-ink-900">{u.name}</span>
                                <span className="text-ink-500">{u.email}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

function TopList({ title, items, metric }) {
    return (
        <div className="card-soft p-6">
            <h3 className="font-serif text-xl text-ink-900 mb-4">{title}</h3>
            {(!items || items.length === 0) ? (
                <p className="text-sm text-ink-500">No data yet.</p>
            ) : (
                <ul className="space-y-3">
                    {items.map((p) => (
                        <li key={p.id} className="flex items-center gap-3">
                            <div className="h-12 w-12 rounded-xl bg-ivory-100 overflow-hidden shrink-0">
                                <img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover" />
                            </div>
                            <div className="flex-1">
                                <Link to={`/product/${p.slug}`} className="text-sm text-ink-900 hover:text-sage-700">{p.name}</Link>
                                <p className="text-xs text-ink-500">{p[metric] || 0} {metric === "views" ? "views" : "clicks"}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
